import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

const Seo = ({ title, description, imageSrc, children }) => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          defaultTitle: title
          defaultDescription: description
          siteUrl
          defaultImage: image
        }
      }
    }
  `);

  const {
    defaultTitle,
    defaultDescription,
    siteUrl,
    defaultImage,
  } = site.siteMetadata;

  // --- Construct Metadata ---
  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: imageSrc ? `${imageSrc}` : `${siteUrl}${defaultImage}`,
    url: siteUrl,
  };

  return (
    <>
      {/* Primary Meta Tags */}
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" /> {/* Default type */}
      <meta property="og:url" content={seo.url} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />

      {/* Canonical Link */}
      <link rel="canonical" href={seo.url} />

      {/* Allow adding extra tags via children (e.g., for og:type override) */}
      {children}
    </>
  );
};

export default Seo;